//Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBS9vSyeato9aMtPGSqcnQ45GZ_y7jziu4",
    authDomain: "dental-care-f0a20.firebaseapp.com",
    projectId: "dental-care-f0a20",
    storageBucket: "dental-care-f0a20.appspot.com",
    messagingSenderId: "76303788996",
    appId: "1:76303788996:web:98dcd345e2acdac4009291"
};

export default firebaseConfig;